import { Itinerary, Day, PointOfInterest, DayActivity, ItineraryActivityType, AccomodationReservation, AccomodationReservationProposal, TransportationReservationRoute, CarReservation } from './itineray.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PoisGeneratorService {

  constructor() { }

  generate(itinerary: Itinerary) {
    itinerary.days.forEach((day) => {
      day.pois = day.pois.filter((poi) => !poi.generated);
      const generatedPois: PointOfInterest[] = this.getPoisFromActivities(day, itinerary);
      generatedPois.forEach((poi) => day.pois.push(poi));
    });
  }

  getReservationById(id: string, itinerary: Itinerary) {
    for (const key in itinerary.reservations) {
      for (const reservation of itinerary.reservations[key]) {
        if (reservation.id === id) return reservation;
      }
    }
  }

  getReservationOrProposalOrRouteById(id: string, itinerary: Itinerary) {
    for (const key in itinerary.reservations) {
      for (const reservation of itinerary.reservations[key]) {
        if (reservation.id === id) {
          if (reservation.proposals && reservation.proposals.length > 0) {
            return this.getPreferredProposal(reservation);
          } else { return reservation; }
        } else {
          if (reservation.routes && reservation.routes.length > 0) {
            for (const route of reservation.routes) {
              if (route.id === id) {
                return route;
              }
            }
          }
        }
      }
    }
  }

  getPreferredProposal(reservation: AccomodationReservation) {
    return reservation.proposals.find((proposal) => proposal.favorite);
  }

  getPoisFromActivities(day: Day, itinerary: Itinerary) {
    if (day.activities) {
      const pois: PointOfInterest[] = [];

      day.activities
        .filter((activity: DayActivity) => activity.type !== ItineraryActivityType.ACCOMODATION)
        .filter((activity: DayActivity) => activity.type !== ItineraryActivityType.FLIGHT)
        .filter((activity: DayActivity) => activity.type !== ItineraryActivityType.CAR)
        .filter((activity: DayActivity) => activity.type !== ItineraryActivityType.TRAIN)
        .filter((activity: DayActivity) => activity.type !== ItineraryActivityType.FERRY)
        .filter((activity: DayActivity) => activity.type !== ItineraryActivityType.BUS)
        .filter((activity: DayActivity) => activity.place)
        .forEach((activity: DayActivity) => pois.push({
          title: activity.title,
          description: activity.description,
          image: activity.image,
          place: activity.place,
          link: activity.link,
          generated: true
        }));

      // AccomodationReservation
      day.activities.filter((activity: DayActivity) => activity.type === ItineraryActivityType.ACCOMODATION).forEach((activity: DayActivity) => {
        const reservation: AccomodationReservation = this.getReservationById(activity.reservationId, itinerary);
        if (reservation != null) {
          const proposal: AccomodationReservationProposal = this.getPreferredProposal(reservation);
          if (proposal != null && proposal.place != null) {
            pois.push({
              title: proposal.name,
              description: proposal.description,
              image: proposal.image,
              place: proposal.place,
              link: proposal.link,
              generated: true
            });
          }
        }
      });

      // TransportationReservation
      day.activities.filter((activity: DayActivity) => activity.type === ItineraryActivityType.FLIGHT || activity.type === ItineraryActivityType.TRAIN || activity.type === ItineraryActivityType.FERRY || activity.type === ItineraryActivityType.BUS).forEach((activity: DayActivity) => {
        const route: TransportationReservationRoute = this.getReservationOrProposalOrRouteById(activity.reservationId, itinerary);
        if (route != null) {
          if (route.fromPlace != null) {
            pois.push({
              title: route.fromPlace.name,
              description: null,
              image: null,
              place: route.fromPlace,
              link: null,
              generated: true
            });
          }
          if (route.toPlace != null) {
            pois.push({
              title: route.toPlace.name,
              description: null,
              image: null,
              place: route.toPlace,
              link: null,
              generated: true
            });
          }
        }
      });

      // CarReservation
      day.activities.filter((activity: DayActivity) => activity.type === ItineraryActivityType.CAR).forEach((activity: DayActivity) => {
        const reservation: CarReservation = this.getReservationById(activity.reservationId, itinerary);
        if (reservation != null) {
          if (reservation.fromPlace != null) {
            pois.push({
              title: reservation.fromPlace.name,
              description: reservation.description,
              image: reservation.image,
              place: reservation.fromPlace,
              link: reservation.link,
              generated: true
            });
          }
          if (reservation.toPlace != null) {
            pois.push({
              title: reservation.toPlace.name,
              description: reservation.description,
              image: reservation.image,
              place: reservation.toPlace,
              link: reservation.link,
              generated: true
            });
          }
        }
      });

      return pois;
    }
    return null;
  }
}
